<div class="c-slotcardStart">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-slotcardStart__container">
    <div
      class="c-slotcardStart__background"
      theming
      themingGroup="slotcard"
      themingAsset="start-background"
      [themingOverride]="event?.assets">
      <div class="c-slotcardStart__info">
        <div
          class="c-slotcardStart__icon"
          theming
          themingGroup="slotcard"
          themingAsset="logo"
          [themingOverride]="event?.assets">
          @if (slotcardStartModalData.properties.extraRewardPercentage != 0) {
            <div class="c-slotcardStart__discount">
              <slotcom-box [classes]="['percent']">
                <span class="text percent">{{ slotcardStartModalData.properties.extraRewardPercentage }}&#37;</span>
                <span class="text extra">{{ 'home.live-ops.slotcard.extra' | translate }}</span>
              </slotcom-box>
            </div>
          }
        </div>

        <div class="c-slotcardStart__text">
          <span class="text title">{{ 'home.live-ops.slotcard.modal-start.title' | translate }}</span>
          <span
            class="text subtitle"
            [ngClass]="(slotcardMinPurchase | number) != 0 ? '' : 'subtitle--margin'">
            {{ 'home.live-ops.slotcard.modal-start.subtitle' | translate }}
            @if (slotcardStartModalData.properties.extraRewardPercentage != 0) {
              <span class="text">{{ 'home.live-ops.slotcard.modal-start.helper' | translate }}</span
              ><span class="text orange"
                >&nbsp;{{ slotcardStartModalData.properties.extraRewardPercentage }}&#37;
                {{ 'home.live-ops.slotcard.extra' | translate | uppercase }}</span
              >
            }
          </span>

          @if ((slotcardMinPurchase | number) != 0) {
            <div>
              <slotcom-box [classes]="['minPurchase']">
                <span class="text"
                  >{{ 'home.live-ops.slotcard.min-purchase' | translate }} {{ slotcardMinPurchase }}
                  {{ slotcardCurrencySymbol }}</span
                >
              </slotcom-box>
            </div>
          }
        </div>

        <div class="c-slotcardStart__timer">
          <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>
          <slotcom-animated-timer
            [showInDays]="true"
            [endDate]="slotcardStartModalData.expirationDate"
            (expired)="closeModal()"></slotcom-animated-timer>
        </div>
      </div>

      <slotcom-button
        class="c-button--pink"
        data-testid="slotcard-start-button"
        (safeClick)="openSlotcard()"
        audioType="functionality">
        {{
          slotcardStartModalData.properties.buttonText[lang]
            ? slotcardStartModalData.properties.buttonText[lang]
            : ('home.buttons.go-promo' | translate | uppercase)
        }}
      </slotcom-button>
    </div>
  </div>
</div>
